import { render, staticRenderFns } from "./Lowerbound.vue?vue&type=template&id=6f128609&scoped=true"
import script from "./Lowerbound.vue?vue&type=script&lang=js"
export * from "./Lowerbound.vue?vue&type=script&lang=js"
import style0 from "./Lowerbound.vue?vue&type=style&index=0&id=6f128609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f128609",
  null
  
)

export default component.exports